import React from "react";
import { useApp } from "../context/AppContext";
import { useBrand } from "../context/BrandContext";
import { Globe, Mail } from "lucide-react";

const hostOf = (url) => (url || "").replace(/^https?:\/\//, "").replace(/\/$/, "");

export const Footer = () => {
  const { setRole } = useApp();
  const brand = useBrand();
  return (
    <footer className="mt-16 border-t border-border bg-card/50" data-testid="app-footer">
      <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-4 px-4 py-6 sm:flex-row sm:px-6">
        <div className="flex items-center gap-2.5">
          {brand.logo_url && (
            <div className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-md bg-white ring-1 ring-border">
              <img src={brand.logo_url} alt={brand.name} className="h-full w-full object-contain" />
            </div>
          )}
          <div className="leading-tight">
            <p className="font-display text-sm font-extrabold">{brand.name}</p>
            {brand.footer_tagline && <p className="text-xs text-muted-foreground">{brand.footer_tagline}</p>}
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
          {brand.website && (
            <a
              href={brand.website}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-website"
              className="flex items-center gap-1.5 text-muted-foreground transition-colors hover:text-primary"
            >
              <Globe className="h-4 w-4" /> {hostOf(brand.website)}
            </a>
          )}
          {brand.contact_email && (
            <a
              href={`mailto:${brand.contact_email}`}
              data-testid="footer-email"
              className="flex items-center gap-1.5 text-muted-foreground transition-colors hover:text-primary"
            >
              <Mail className="h-4 w-4" /> {brand.contact_email}
            </a>
          )}
        </div>

        <div className="flex items-center gap-3">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} {brand.name}</p>
          <span className="text-muted-foreground/40">·</span>
          <button
            data-testid="footer-admin-link"
            onClick={() => setRole("admin")}
            className="text-xs text-muted-foreground/70 underline-offset-2 transition-colors hover:text-primary hover:underline"
          >
            Accès Admin
          </button>
        </div>
      </div>
    </footer>
  );
};
